<template>
  <Icon class="market-mark" :name="name" />
</template>
<script>
import Icon from 'com/Icon'
import { MARKET_TYPE } from 'const/stock'
export default {
  name: 'MarketMark',
  components: { Icon },
  props: {
    market: String
  },
  computed: {
    name() {
      return {
        [MARKET_TYPE.US]: 'us',
        [MARKET_TYPE.HK]: 'hk'
      }[this.market]
    }
  }
}
</script>
<style scoped>
.market-mark {
  display: inline-block;
  width: 16px;
  height: 14px;
  vertical-align: middle;
}
</style>
